<ng-container *transloco="let t">
  <div class="pt-62-32 pb-300-100">
    <div class="d-flex flex-column">
      <div class="contestants-filter py-3 mb-3 d-flex justify-content-between align-items-center">
        <div class="d-flex flex-row">
          <div class="px-0 px-lg-4 px-md-0 me-md-3 pb-3 pb-md-0">
            <app-search [searchBarClass]="'extra-small'" [placeholder]="t('explore.search')"
                        [inputValue]="name"/>
          </div>
          <form #f>
            <div class="contestants-filter__grid">
              <div class="contestants-filter__grid-inner">
                <div ngbDropdown class="dropdown-small" container="body">
                  <div class="dropdown" id="genderDropdown" ngbDropdownToggle>
                    {{
                      gender
                        ? t("app.common.gender." + gender) : t("competitor.table.gender")
                    }}
                  </div>
                  @if (competitorCategories?.genders?.size ?? 0 > 0) {
                    <div ngbDropdownMenu aria-labelledby="genderDropdown">
                      <button ngbDropdownItem>
                        {{ t("app.common.all") }}
                        @if (gender === undefined) {
                          <i class="bi bi-check"></i>
                        }
                      </button>
                      @for (item of competitorCategories?.genders;track item) {
                        <button ngbDropdownItem>
                          {{ t("app.common.gender." + item) }}
                          @if (item === gender) {
                            <i class="bi bi-check"></i>
                          }
                        </button>
                      }
                    </div>
                  }
                </div>
                <div>
                  @if (competitorCategories?.category?.size ?? 0 > 0) {
                    <div ngbDropdown class="dropdown-small" container="body">
                      <div class="dropdown" id="categoryDropdown" ngbDropdownToggle>
                        {{ category ? category : t("competitor.table.category") }}
                      </div>
                      <div ngbDropdownMenu aria-labelledby="categoryDropdown">
                        <button ngbDropdownItem>
                          {{ t("app.common.all") }}
                          @if (category === undefined) {
                            <i class="bi bi-check"></i>
                          }
                        </button>
                        @for (item of competitorCategories?.category;track item) {
                          <button ngbDropdownItem>
                            {{ item }}
                            @if (item == category) {
                              <i class="bi bi-check"></i>
                            }
                          </button>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="text-uppercase cursor-pointer pe-50 fw-semibold" (click)="onGetFileFromServer('pdf')">
          {{ t('app.common.export.to.pdf') }}
        </div>
      </div>
      <div class="pt-20">
        <app-table-section-header [title]="t('league.challenger.man')"/>
        <div class="pt-20">
          <app-series-table/>
        </div>
      </div>

      <div class="pt-50-48">
        <app-table-section-header [title]="t('league.challenger.women')"/>
        <div class="pt-20">
          <app-series-table/>
        </div>
      </div>

      <div class="pt-50-48">
        <app-table-section-header [title]="t('league.active.man')"/>
        <div class="pt-20">
          <app-series-table/>
        </div>
      </div>

      <div class="pt-50-48">
        <app-table-section-header [title]="t('league.active.women')"/>
        <div class="pt-20">
          <app-series-table/>
        </div>
      </div>

    </div>
  </div>
</ng-container>
